<template>  
  <div >
    <el-table
      :data="data"    
      highlight-current-row
      @current-change="onRowSelectHandler"
      :height="tbHeight"
      show-summary
      :summary-method="summary" 
    >     
      <!-- <div v-if="checkType" > -->
        <el-table-column sortable label="หมวด" prop="name"   width="115">
          <template #default="scope">     
              <span class="text-primary fw-bold">{{ scope.row.name }} </span>    
          </template>
        </el-table-column>
        <el-table-column sortable
          label="Stock"
          align="right"
          width="100"
          :prop="checkType?'stockWeight':'stockQuan'">
          <template #default="scope">
            <div v-if="checkType" >{{ numberWithCommas(scope.row.stockWeight, 2) }} </div>
            <div v-else >{{ numberWithCommas(scope.row.stockQuan, 0) }} </div>
          </template>
        </el-table-column>
        <el-table-column sortable
          label="AVG3M"
          align="right"
          width="100"
          :prop="checkType?'last3Month':'qLast3Month'">
          <template #default="scope">            
            <div v-if="checkType" >{{ numberWithCommas(scope.row.last3Month, 2) }}  </div>
            <div v-else >{{ numberWithCommas(scope.row.qLast3Month, 0) }} </div>
          </template>
        </el-table-column>
        <el-table-column sortable
          label="Stock(วัน)"
          align="right"
          width="110"
          :prop="checkType?'stockWeightDay':'stockQuanDay'">
          <!-- <template #default="scope">
            <div v-if="checkType && scope.row.last3Month>0" >{{ numberWithCommas((scope.row.stockWeight/scope.row.last3Month)*30, 0) }} </div>
            <div v-else-if="!checkType && scope.row.qLast3Month>0" >{{ numberWithCommas((scope.row.stockQuan/scope.row.qLast3Month)*30, 0) }} </div>
          </template> -->
          <template #default="scope">      
            <div v-if="scope.row.stockQuanDay != 99999" >      
              <div v-if="checkType" >{{ numberWithCommas(scope.row.stockWeightDay, 0) }}  </div>
              <div v-else >{{ numberWithCommas(scope.row.stockQuanDay, 0) }} </div>
            </div>
            <div v-else>
              <strong class="text-danger">DS</strong>
            </div>
          </template>
        </el-table-column>
        <el-table-column sortable
          label="TM"
          align="right"
          :prop="checkType?'thisMonth':'qThisMonth'">
          <template #default="scope">
            <div v-if="checkType" >{{ numberWithCommas(scope.row.thisMonth, 2) }} </div>
            <div v-else >{{ numberWithCommas(scope.row.qThisMonth, 0) }} </div>
          </template>
        </el-table-column>
        <el-table-column sortable
            label="LM"
            align="right"
            :prop="checkType?'lastMonth':'qLastMonth'">
            <template #default="scope">
              <div v-if="checkType" >{{ numberWithCommas(scope.row.lastMonth, 2) }} </div>
              <div v-else >{{ numberWithCommas(scope.row.qLastMonth, 0) }} </div>
            </template>
        </el-table-column>
        <el-table-column sortable
          label="L2M"
          align="right"
          :prop="checkType?'last2Month':'qLast2Month'">
          <template #default="scope">            
            <div v-if="checkType" >{{ numberWithCommas(scope.row.last2Month, 2) }}  </div>
            <div v-else >{{ numberWithCommas(scope.row.qLast2Month, 0) }} </div>
          </template>
        </el-table-column>
       
        <el-table-column sortable v-if="thisMonth>1"
          label="TY"
          align="right"
          :prop="checkType?'thisYear':'qThisYear'">
          <template #default="scope">            
            <div v-if="checkType" >{{ numberWithCommas(scope.row.thisYear, 2) }}  </div>
            <div v-else >{{ numberWithCommas(scope.row.qThisYear, 0) }} </div>
          </template>
        </el-table-column>
        <el-table-column sortable v-else
          label="LY"
          align="right"
          :prop="checkType?'lastYear':'qLastYear'">
          <template #default="scope">            
            <div v-if="checkType" >{{ numberWithCommas(scope.row.lastYear, 2) }}  </div>
            <div v-else >{{ numberWithCommas(scope.row.qLastYear, 0) }} </div>
          </template>
        </el-table-column>
        <!-- <el-table-column
          label="L2Y"
          align="right"
          :prop="checkType?'last2Year':'qLast2Year'">
          <template #default="scope">            
            <div v-if="checkType" >{{ numberWithCommas(scope.row.last2Year, 2) }}  </div>
            <div v-else >{{ numberWithCommas(scope.row.qLast2Year, 2) }} </div>
          </template>
        </el-table-column>
        <el-table-column
          label="L3Y"
          align="right"
          :prop="checkType?'last3Year':'qLast3Year'">
          <template #default="scope">            
            <div v-if="checkType" >{{ numberWithCommas(scope.row.last3Year, 2) }}  </div>
            <div v-else >{{ numberWithCommas(scope.row.qLast3Year, 2) }} </div>
          </template>
        </el-table-column> -->
    </el-table>
    
  </div>
  
</template>

<script>

import { numberWithCommas, formatDateFromISO, formatDateThDate } from "@/utils";
export default {
  props: {
    data: Array,
    selected: String,
    height: Number,
    checkType:Boolean
  },  
  data(){
      return{
             
      }
  },
  computed: {
    windowHeight() {
      return this.$store.getters.getWindowHeight
    },
    tbHeight() {
      return this.height ? this.height : (this.windowHeight - 140)
    },
    stockWeightAVG() {
      if (this.data.length === 0) {
        return 0;
      }
      const sumWStock = this.data.reduce((acc, cur) =>acc + cur.stockWeight , 0);
      const sumAVG3M = this.data.reduce((acc, cur) => acc + (cur.last3Month/30) , 0);
      if(sumAVG3M>0){        
        return this.numberWithCommas(sumWStock/sumAVG3M,0)
      }else{
        return 0;
      }
      //หรือ sum stock(วัน) = Sum(stock)/Sum(AVG3M/30)
    },
    thisMonth(){
        var date = new Date()
      return date.getMonth()+1;
    },
    stockQuanAVG() {
      if (this.data.length === 0) {
        return 0;
      }
  
      const sumQStock = this.data.reduce((acc, cur) =>acc + cur.stockQuan , 0);
      const sumQAVG3M = this.data.reduce((acc, cur) => acc + (cur.qLast3Month/30) , 0);
      if(sumQAVG3M>0){
        return this.numberWithCommas(sumQStock/sumQAVG3M,0)
      }else{
        return 0;
       
      }
     //หรือ sum stock(วัน) = Sum(stock)/Sum(AVG3M/30)
      
    }
  },
  methods: {
    numberWithCommas,
    onRowSelectHandler(selection) {
      // console.log(selection)
      if(selection)
      this.$emit('select', selection)
    },
    summary({columns, data}) {
      const sums = [];
      columns.forEach((col, index) => {     
        var sumColumns = [];
        var sumColumnsQ = [];
        if(index === 0) {
          sums[index] = 'เฉลี่ย';
        }
        if(index === 3) {
          if(this.checkType){
            sums[index] = this.stockWeightAVG;
          }else{
            sums[index] = this.numberWithCommas(this.stockQuanAVG,0);
          }
          
        }
        if(this.checkType){
            sumColumns = ['stockWeight','thisMonth', 'lastMonth','last2Month','last3Month','thisYear','lastYear']
        }else{
            sumColumnsQ =  ['stockQuan','qThisMonth', 'qLastMonth','qLast2Month','qLast3Month','qThisYear','qLastYear']
        }
        if(sumColumns.includes(col.property)) {
          sums[index] = this.numberWithCommas(data.reduce(
            (prev, curr) => {
              return prev +curr[col.property]
            },
            0
          ),2)
        }
        if(sumColumnsQ.includes(col.property)) {
          sums[index] = this.numberWithCommas(data.reduce(
            (prev, curr) => {
              return prev +curr[col.property]
            },
            0
          ),0)
        }
        
      })      
      return sums;
    },
   
  },
}

</script>

<style scoped>
  .el-table {
      font-size: 13px;
  }
</style>